import { render, staticRenderFns } from "./UiAudioPlayer.vue?vue&type=template&id=37ac2694&scoped=true&"
import script from "./UiAudioPlayer.vue?vue&type=script&lang=js&"
export * from "./UiAudioPlayer.vue?vue&type=script&lang=js&"
import style0 from "./UiAudioPlayer.vue?vue&type=style&index=0&id=37ac2694&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ac2694",
  null
  
)

export default component.exports